import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ help, ...args }) {
    super(args)
    this.children = [this.getComponentWithVModel('el-switch')]
    if (help) {
      this.children.push({
        component: 'p',
        innerText: help,
        attrs: { class: 'field-info' }
      })
    }
  }
}
